import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SidebarTaskGroupUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';

@Component({
  selector: 'ri-resolution-ui-create-package-group-template',
  templateUrl: './create-package-group-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatePackageGroupTemplateComponent {
  readonly group = input.required<SidebarTaskGroupUi>();
}
